// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__MUIZM","productName":"Table_productName__Rdqbc"};